import React from 'react';
import PropTypes from 'prop-types';
import Amount from "components/Display/Amount";
import DateTime from "components/Display/ViewDateTime";
import ClaimState from "../Display/ClaimState";
import Origin from "../Display/Origin";

const ClaimInfo = ({ data }) => {

  if (!data || Object.keys(data).length === 0){
    return (
      <div/>
    );
  }

  return (
    <div className="calc-setting-table">
      <table className="table">
        <colgroup>
          <col />
          <col />
        </colgroup>
        <thead>
        <tr>
          <th colSpan="2" className="text-left calc-setting-table-header">Upplýsingar um kröfu</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th className="text-right">Kröfunúmer</th>
          <td className="text-right">{data.claimNumber}</td>
        </tr>
        <tr>
          <th className="text-right">Dagssetnign kröfu</th>
          <td className="text-right"><DateTime skipTime={true} data={data.claimDate}/></td>
        </tr>
        <tr>
          <th className="text-right">Tegund</th>
          <td className="text-right">{data.claimType}</td>
        </tr>
        <tr>
          <th className="text-right">Uppruni</th>
          <td className="text-right"><Origin data={data.originID}/></td>
        </tr>
        <tr>
          <th className="text-right">Staða</th>
          <td className="text-right"><ClaimState data={data.claimState}/></td>
        </tr>
        <tr>
          <th className="text-right">Skuldari</th>
          <td className="text-right">{data.debtorRegno}</td>
        </tr>
        <tr>
          <th className="text-right">Kröfuhafi</th>
          <td className="text-right">{data.claimOwnerRegno}</td>
        </tr>
        <tr>
          <th className="text-right">Embætti</th>
          <td className="text-right">{data.publicOfficeRegno}</td>
        </tr>
        <tr>
          <th className="text-right">Umboðsmaður</th>
          <td className="text-right">{data.representativeRegno}</td>
        </tr>
        <tr>
          <th className="text-right">Upphæð</th>
          <td className="text-right"><Amount data={data.capital}/></td>
        </tr>
        <tr>
          <th className="text-right">Gengi</th>
          <td className="text-right">{data.currency}</td>
        </tr>
        </tbody>
      </table>
    </div>
  );
};

ClaimInfo.propTypes = {
  data: PropTypes.object,
};

export default ClaimInfo;



// WEBPACK FOOTER //
// ./src/pages/ClaimTracker/Claim/ClaimInfo.js